import React from 'react'

const Logo = ({ className = "w-11 h-6", variant = "full" }) => {
  const flowFill = 'white'
  
  if (variant === "icon") {
    return (
      <svg 
        width="11" 
        height="13" 
        viewBox="0 0 11 13" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path d="M2.0575 10.6538H0.960815V9.42139H2.0575V10.6538ZM4.86121 1.96631H3.46179V3.57764H4.86121V4.81006H3.46179V9.42139H2.0575V4.81006H0.960815V3.57764H2.0575V1.9624H3.45691V0.73291H4.86121V1.96631Z" fill={flowFill}/>
        <path d="M6.26453 11.0327H9.07312V12.2651H4.86121V4.81006H6.26453V11.0327ZM9.07312 8.56689H10.4764V11.0327H9.07312V8.56689ZM10.4764 7.27588H9.07312V8.56689H7.66882V7.24463H9.07312V4.81006H10.4764V7.27588ZM9.07312 4.81006H6.26453V3.57666H9.07312V4.81006Z" fill="url(#paint0_linear_6467_322)"/>
        <defs>
          <linearGradient id="paint0_linear_6467_322" x1="4.86121" y1="3.57666" x2="10.4764" y2="12.2651" gradientUnits="userSpaceOnUse">
            <stop stopColor="#0B64FF"/>
            <stop stopColor={flowFill} offset="1"/>
          </linearGradient>
        </defs>
      </svg>
    )
  }
  
  // Full logo variant (default)
  return (
    <svg 
      width="41" 
      height="11" 
      viewBox="0 0 41 11" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M1.98083 10.4595H0.884155V9.22705H1.98083V10.4595ZM10.9115 3.20264C12.6632 3.20287 13.9465 4.51065 13.9467 6.29834C13.9467 8.09818 12.6633 9.4065 10.9115 9.40674C9.1715 9.40674 7.88708 8.09834 7.88708 6.29834C7.88723 4.51049 9.1716 3.20264 10.9115 3.20264ZM4.78455 1.77197H3.38513V3.38232H5.88123V0.538574H7.26111V9.22705H5.88123V4.61572H3.38513V9.22705H1.98083V4.61572H0.884155V3.38232H1.98083V1.76807H3.38025V0.538574H4.78455V1.77197ZM16.3636 7.42627L17.7435 3.38232H19.184L20.5638 7.42627L21.7279 3.38232H23.1439L21.2719 9.22705H19.8793L18.4281 5.02686L17.0121 9.22705H15.5834L13.6879 3.38232H15.1752L16.3636 7.42627ZM10.9115 4.4624C10.0596 4.4624 9.27881 5.08653 9.27869 6.29834C9.27869 7.51034 10.0595 8.15869 10.9115 8.15869C11.7753 8.15846 12.5433 7.52212 12.5433 6.29834C12.5432 5.08676 11.7752 4.46263 10.9115 4.4624Z" fill={flowFill}/>
      <path d="M34.2738 3.38232H35.4857V4.61865H34.2738V7.33057C34.2738 7.84651 34.502 8.06201 35.0179 8.06201C35.2095 8.06201 35.4369 8.02624 35.4974 8.01416V9.1665C35.413 9.20264 35.1491 9.29834 34.6459 9.29834C33.5659 9.29833 32.8939 8.6501 32.8939 7.55811V4.61865H31.8138V3.38232H32.8939V1.59424H34.2738V3.38232ZM25.0092 7.99365H27.8168V9.22705H23.6049V1.77197H25.0092V7.99365ZM31.434 9.22705H30.0541V3.38232H31.434V9.22705ZM40.7142 4.55811L37.7142 8.00244H40.7738V9.22705H35.9984V8.01416L38.9623 4.60693H36.058V3.38232H40.7142V4.55811ZM27.8168 5.52783H29.2211V7.99365H27.8168V5.52783ZM29.2211 4.23779H27.8168V5.52783H26.4135V4.20654H27.8168V1.77197H29.2211V4.23779ZM31.434 2.82764H30.0541V1.59424H31.434V2.82764ZM27.8168 1.77197H25.0092V0.538574H27.8168V1.77197Z" fill="url(#paint0_linear_6467_319)"/>
      <defs>
        <linearGradient id="paint0_linear_6467_319" x1="23.6049" y1="0.538574" x2="33.173" y2="8.04434" gradientUnits="userSpaceOnUse">
          <stop stopColor="#0B64FF"/>
          <stop stopColor={flowFill} offset="1"/>
        </linearGradient>
      </defs>
    </svg>
  )
}

export default Logo
